import {
  ADMIN_CONTACT_CITY,
  ADMIN_CONTACT_PARTNER,
  ADMIN_CONTACT_PARTNER_ADMIN_ROLE,
  ADMIN_CONTACT_SCHOOL,
  ADMIN_CONTACT_SCHOOL_ADMIN_ROLE,
  ADMIN_CONTACT_SCHOOL_NET_ADMIN_ROLE
} from '../../constants/admin.contacts.constants';

const canDeleteContact = (user, contact) => {
  if (user.type === ADMIN_CONTACT_CITY) {
    return true;
  }

  let canDelete = false;

  if (user.type === ADMIN_CONTACT_PARTNER) {
    user.permissionsWithTreepaths?.forEach((p) => {
      const organizationId = p.treePath;
      if (
        p.role === ADMIN_CONTACT_PARTNER_ADMIN_ROLE &&
        contact.type === ADMIN_CONTACT_PARTNER &&
        (contact?.roles?.map((r) => r.treePath)?.includes(organizationId) ?? false)
      ) {
        canDelete = true;
      }
    });
  }

  if (user.type === ADMIN_CONTACT_SCHOOL) {
    user.permissionsWithTreepaths?.forEach((p) => {
      if (
        [ADMIN_CONTACT_SCHOOL_NET_ADMIN_ROLE, ADMIN_CONTACT_SCHOOL_ADMIN_ROLE].includes(p.role) &&
        contact.type === ADMIN_CONTACT_SCHOOL
      ) {
        canDelete = true;
      }
    });
  }

  return canDelete;
};

const _isAdminOfSomeContactsOrganizations = (user, contact) => {
  const organizationsWhereIsAdmin = user?.permissionsWithTreepaths
    ?.filter((p) => p.role === ADMIN_CONTACT_PARTNER_ADMIN_ROLE)
    ?.map((p) => p?.treePath);
  return contact.roles?.some((r) => organizationsWhereIsAdmin?.includes(r?.treePath));
};

const canUpdateContact = (user, contact) => {
  switch (contact.type) {
    case ADMIN_CONTACT_CITY:
      return user?.type === ADMIN_CONTACT_CITY;
    case ADMIN_CONTACT_PARTNER:
      const isAdmin = user?.permissions?.includes(ADMIN_CONTACT_PARTNER_ADMIN_ROLE);

      return (
        user?.type === ADMIN_CONTACT_CITY ||
        (user?.type === ADMIN_CONTACT_PARTNER && isAdmin && _isAdminOfSomeContactsOrganizations(user, contact))
      );
    case ADMIN_CONTACT_SCHOOL:
      return true;

    default:
      return false;
  }
};

const canAddPartnerContacts = (user) => {
  return (
    user?.type === ADMIN_CONTACT_CITY ||
    (user?.type === ADMIN_CONTACT_PARTNER && user?.permissions?.includes(ADMIN_CONTACT_PARTNER_ADMIN_ROLE))
  );
};

const contactsPermissionsService = {
  canDeleteContact,
  canUpdateContact,
  canAddPartnerContacts
};

export default contactsPermissionsService;
